module.exports = __webpack_public_path__ + "static/img/product_img_01.360dbb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_01.png
// module id = FOYw
// module chunks = 0